import {inspectMap} from './map-validation';
import type { Progress, WorldData } from './types';
export const defaults: Progress = { fruit: [], discoveries: ['home'], bests: {}, ghosts: {}, completed: [], settings: { assist: 0, character: 'default', quality: 'high', volume: .45, sensitivity: 1, invertY: false, reducedMotion: false, accessory: 'none', guidance: true } };
export function loadProgress(): Progress {
    try {
        const p = JSON.parse(localStorage.getItem('canopy.progress.v1') || 'null');
        if (!p || !Array.isArray(p.fruit) || !Array.isArray(p.discoveries))
            return structuredClone(defaults);
        return { ...structuredClone(defaults), ...p, settings: { ...defaults.settings, ...p.settings } };
    }
    catch {
        return structuredClone(defaults);
    }
}
export function saveProgress(p: Progress) {
    try {
        localStorage.setItem('canopy.progress.v1', JSON.stringify(p));
        return true;
    }
    catch {
        return false;
    }
}
export function validateMap(value: unknown): string[] { return inspectMap(value).filter(i=>i.severity==='error').map(i=>i.message); }
export function exportJSON(name: string, data: unknown) { const url = URL.createObjectURL(new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' })); const a = document.createElement('a'); a.href = url; a.download = name; a.click(); setTimeout(() => URL.revokeObjectURL(url), 1000); }
